// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountSettings --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {Exact} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountPayoutSettingsFragment} from './stripeAccountPayoutSettingsFragment';

import type {StripeAccountPayoutSettingsFragmentData} from './stripeAccountPayoutSettingsFragment';

const doc = gql`
  fragment StripeAccountSettingsFragment on OpenapiAccountSettings {
    dashboard {
      display_name
    }
    payouts {
      ...StripeAccountPayoutSettingsFragment
    }
    payments {
      statement_descriptor
      statement_descriptor_kana
      statement_descriptor_kanji
      statement_descriptor_prefix
      statement_descriptor_prefix_kana
      statement_descriptor_prefix_kanji
    }
  }

  ${stripeAccountPayoutSettingsFragment}
`;

export const stripeAccountSettingsFragment: StripeAccountSettingsFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountSettingsFragmentData = {
  readonly __typename: 'OpenapiAccountSettings';
  readonly dashboard: {
    readonly __typename: 'OpenapiAccountDashboardSettings';
    readonly display_name: string | null;
  };
  readonly payouts: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountPayoutSettings'},
    [StripeAccountPayoutSettingsFragmentData]
  > | null;
  readonly payments: {
    readonly __typename: 'OpenapiAccountPaymentsSettings';
    readonly statement_descriptor: string | null;
    readonly statement_descriptor_kana: string | null;
    readonly statement_descriptor_kanji: string | null;
    readonly statement_descriptor_prefix: string | null;
    readonly statement_descriptor_prefix_kana: string | null;
    readonly statement_descriptor_prefix_kanji: string | null;
  };
};

export type StripeAccountSettingsFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountSettingsFragmentPermissions = {
  ...stripeAccountPayoutSettingsFragment.permissions,
} as const;

doc.permissions = stripeAccountSettingsFragmentPermissions;

export type StripeAccountSettingsFragmentPermissions = V1PermissionToken<
  typeof stripeAccountSettingsFragmentPermissions
>;

export type StripeAccountSettingsFragmentDocument = GraphQlDocument<
  StripeAccountSettingsFragmentData,
  StripeAccountSettingsFragmentVariables,
  StripeAccountSettingsFragmentPermissions
>;
